import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import searchFill from '@iconify/icons-eva/search-fill';
import trash2Fill from '@iconify/icons-eva/trash-2-fill';
import roundFilterList from '@iconify/icons-ic/round-filter-list';
// material
import { useTheme, styled } from '@material-ui/core/styles';
import {
  Box,
  Toolbar,
  Tooltip,
  IconButton,
  Typography,
  OutlinedInput,
  InputAdornment,
  FormControlLabel,
  Switch,
  Checkbox,
  Stack
} from '@material-ui/core';

// ----------------------------------------------------------------------

const RootStyle = styled(Toolbar)(({ theme }) => ({
  height: 96,
  display: 'flex',
  justifyContent: 'space-between',
  padding: theme.spacing(0, 1, 0, 3)
}));

const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
  width: 240,
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter
  }),
  '&.Mui-focused': { width: 320, boxShadow: theme.customShadows.z8 },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${theme.palette[500_32]} !important`
  }
}));

// ----------------------------------------------------------------------

TableListToolbar.propTypes = {
  numSelected: PropTypes.number,
  filterName: PropTypes.string,
  onFilterName: PropTypes.func,
  switchButtonResponse: PropTypes.func,
  switchButton: PropTypes.bool,
  status: PropTypes.bool
};

export default function TableListToolbar({
  numSelected,
  filterName,
  onFilterName = () => {},
  switchButton,
  status,
  switchButtonResponse = () => {}
}) {
  return (
    <RootStyle
      sx={{
        height: '80px'
      }}
    >
      {numSelected > 0 ? (
        <Typography component="div" variant="subtitle1">
          {numSelected} selected
        </Typography>
      ) : (
        <SearchStyle
          value={filterName}
          onChange={onFilterName}
          placeholder="Search ..."
          sx={{ height: '45px' }}
          startAdornment={
            <InputAdornment position="start">
              <Box component={Icon} icon={searchFill} sx={{ color: 'text.disabled' }} />
            </InputAdornment>
          }
        />
      )}

      {switchButton ? (
        <Tooltip title={status ? 'Active' : 'InActive'}>
          <Stack direction="row" alignItems="center">
            <FormControlLabel
              style={{ marginRight: 0 }}
              control={<Checkbox />}
              label=""
              onChange={(e) => switchButtonResponse(e)}
            />
            <Typography variant="subtitle1">{status ? 'Active' : 'InActive'}</Typography>
          </Stack>
        </Tooltip>
      ) : (
        ''
      )}
    </RootStyle>
  );
}
